<template>
  <div id="footer" class="container-fluid">
    <div class="flex" style="padding-top: 20px;justify-content: space-between">
      <div class="logo">
        <img src="@/assets/img/logo.png" alt="logo图">
        <p>{{ baseConfig.email }}</p>
        <p style="margin-top: 20px;">{{ baseConfig.address }} </p>
        <p>{{baseConfig.address1}}</p>
        <img class="weibo" style="right: 115px;" src="../assets/img/weibo.png" :alt="$t('footer.weiboAlt')" srcset="">
        <img class="weixin" style="right: 65px;" src="../assets/img/weixin.png" :alt="$t('footer.wechatAlt')" srcset="">
      </div>
      <div class="flex" style="flex-wrap: wrap;position: relative;">

        <p>{{$t('footer.about')}}</p>
        <p>{{$t('footer.services[0]')}}</p>
        <p>{{$t('footer.services[1]')}}</p>


        <p>{{$t('footer.services[2]')}}</p>
        <p>{{$t('footer.services[3]')}}</p>
        <p>{{$t('footer.services[4]')}}</p>



        <p>{{$t('footer.services[5]')}}</p>
        <p>{{$t('footer.services[6]')}}</p>
        <p>{{$t('footer.services[7]')}}</p>
        <img class="qrcode" style="right: 0px;" :src="baseConfig.wechatQr" :alt="$t('footer.qrCodeAlt')" srcset="">
      </div>
    </div>
    <div class="bot-area">
      <p class="copy">
      <p>{{$t('footer.company')}}（厦门）信息科技有限公司 版权所有</p> <span><a href="https://beian.miit.gov.cn/" target="_blank" class="link">{{ baseConfig.recordNumber }}</a></span>
      </p>
      <p class="copy">
        {{ baseConfig.copyright }}</p>
    </div>

  </div>
</template>
<script>
import { baseConfig } from '../api/api'
export default {
  name: "Footer",
  data() {
    return {
      baseConfig: {}
    };
  },
  mounted() {
    this.getConfig();
  },
  methods: {
    getConfig() {
      baseConfig()
        .then(res => {
          let obj = JSON.parse(res.data.body);
          console.log(obj)
          this.baseConfig = { ...obj }
        })
        .catch(err => {

        })
    },
  },
};
</script>
<style scoped stylus="less">
#footer {
  width: 100%;
  box-sizing: border-box;
  margin: auto;
  height: 100%;
  color: #fff;
  background: #004984;
  overflow: hidden;
  text-align: center;
  padding: 40px 200px;
  position: relative;


}

.bot-area {
  margin-top: 70px;
  padding-top: 30px;
  border-top: 1px solid #3373A7;
}

.flex {
  display: flex;
  align-items: flex-start;

}

.flex p {
  width: 33%;
  font-size: 16px;
  text-align: right;
  margin: 10px 0;
}

.logo {
  position: relative;
  min-width: 320px;



}

.logo img {
  width: 200px;

  margin-bottom: 40px;


}

.logo p {
  width: 100% !important;
  margin-top: 10px;
  text-align: left !important;
}

.weibo,
.weixin {
  position: absolute;
  width: 30px !important;
  height: 30px;
  top: 98px;

}

.title {
  font-size: 25px;
  margin-bottom: 20px;
}

.qrcode {
  width: 132px;
  height: 132px;
  position: absolute;
  right: 0;
  bottom: -140px;
}

.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}

.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}

.copy {
  color: white;
  font-size: 14px;
  margin: 10px 0 10px;
}

@media screen and (max-width: 768px) {
  .title {
    font-size: 20px;
  }

  .address_tel_fax {
    font-size: 12px;
  }

  .weibo,
.weixin {
  position: absolute;
  width: 20px !important;
  height: 20px;
  top: 98px;

}
  .email_wx {

    font-size: 12px;
  }

  .copy {
    font-size: 12px;
    margin: 30px 0 10px;

    span {
      display: block;
      padding: 2px 0;
    }
  }

  .logo img {
    width: 100px;
    margin-bottom: 40px;
  }

  .qrcode {
    width: 52px;
    height: 52px;
    position: absolute;
    right: 16%!important;
    bottom: -5vw;
  }

  .flex p {
    width: 50%;
    font-size: 9px;
    text-align: center;
    margin: 10px 0;
  }

  .logo {
    min-width: 165px !important;
  }

  .weibo {
    right: 10px !important;
    top: 70px !important;
  }

  .weixin {
    right: 40px !important;
    top: 70px !important;
  }

}

@media screen and (max-width: 1250px) {
  #footer {
    width: 100%;
    padding: 5px 10px;

    .copy {
      margin: 10px;
    }

    .bot-area {
      margin-top: 30px;
    }
  }
}

.link {
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue